import { create } from "zustand";
import type { DashboardField } from "../types/contract";

// Session-only, not persisted — dismissing is fine, the user can always add JD data later from the
// map.
interface NewFieldPromptState {
  pending: DashboardField | null;
  ask: (field: DashboardField) => void;
  // Optional fieldId makes dismissal FIELD-AWARE: a stale prompt instance whose in-flight JD pull
  // resolves AFTER a newer field became pending must not clear the newer one.
  dismiss: (fieldId?: string) => void;
}

export const useNewFieldPrompt = create<NewFieldPromptState>((set) => ({
  pending: null,
  ask: (field) => set({ pending: field }),
  dismiss: (fieldId) =>
    set((s) =>
      fieldId !== undefined && s.pending?.field_id !== fieldId
        ? s
        : { pending: null },
    ),
}));
